<script>
    /* v-model container for form post element  */
    export default {
        data() {
            return Object.assign({
                select_all : false,
                type : ['admin'],
                module : '',
            }, __FORM__, {locale: window.locale});
        },
        props : {
            form_type : {
                type : String,
                default : 'admin',
            }
        },
        computed: {
            form_permissions() {
                let result = [];
                _.each(this.permissions, (flag, key) => {
                    if(flag) {
                        result.push(key);
                    }
                });
                return result;
            }
        },
        watch : {
            select_all() {
                _.each(this.permissions, (permission, index) => {
                   this.permissions[index] = this.select_all;
                });
            },
        },
        mounted() {
        },
        methods : {
            submit() {
                let formData = this.getFormData();

                this.$validator.validateAll()
                    .then((result) => {
                        if(result) {
                            let formData = this.getFormData();
                            let ajaxSuccessCallback = (response) => {
                                this.$nextTick(function () {
                                    window.location.href = this.redirect_url;
                                    this.$store.commit('setRedirectNotification', response.data.msg);
                                    this.$store.commit('setNotificationType', 'success');
                                });
                            };
                            let ajaxFailCallback = (error) => {
                                if (error.response.status == '422') {
                                    this.$store.commit('setValidationError', error.response.data.errors)
                                } else {
                                    this.$store.commit('setError', error.response.data.msg)
                                }
                            };
                            this.$root.ajax_call(this.url, this.method, formData, ajaxSuccessCallback, ajaxFailCallback, true);

                        } else {
                            this.$store.commit('setVeeValidationError', this.errors);
                        }
                    });

            },
            getFormData() {
                let formData = {};
                formData = {
                    permissions : this.form_permissions,
                    type : this.type,
                    form_type : this.form_type,
                    module : this.module,
                    include_own_permissions : this.include_own_permissions,
                };

                return formData;
            },
        },
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/Modules/system-management/administrator/AdminUserPermissionForm.vue